import { i18n } from '@lingui/core'
import { I18nProvider, useLingui } from '@lingui/react'
import { useLanguage } from 'helpers/activateLanguage'
import React from 'react'
import { withCookies } from 'react-cookie'

const supportedLocales = ['da', 'en', 'de', 'nn']

function normalizeLocale(locale) {
  const code = locale?.substring(0, 2)?.toLowerCase()
  if (code === 'nb' || code === 'no') return 'nn'
  return code
}

function resolveLocale({ cookieLocale, envLocale }) {
  const has = (locale) => supportedLocales.includes(locale)

  if (has(cookieLocale)) return cookieLocale
  if (has(envLocale)) return envLocale
  return 'da'
}

function I18nWatchLocale({ children }) {
  const { i18n: i18nWatch } = useLingui()
  if (!i18nWatch.locale) return null
  return <React.Fragment key={i18nWatch.locale}>{children}</React.Fragment>
}

function I18nLoader(props) {
  const cookieLocale = normalizeLocale(props.cookies.getAll()?.locale)
  const envLocale = normalizeLocale(process.env.REACT_APP_LOCALE)
  const selectedLocale = resolveLocale({
    cookieLocale,
    envLocale,
  })

  useLanguage(selectedLocale)

  return (
    <I18nProvider i18n={i18n} forceRenderOnLocaleChange={false}>
      <I18nWatchLocale>{props.children}</I18nWatchLocale>
    </I18nProvider>
  )
}

export default withCookies(I18nLoader)
